<ion-header mode="md">
  <ion-toolbar class="ion-text-center">
    <ion-item lines="none">
      <ion-img class="logo" src="../assets/images/app-logo.svg"></ion-img>
    </ion-item>
  </ion-toolbar>
</ion-header>

<ion-content full>
  <ion-grid class="box">
    <ion-row justify-content-center class="content-padding-vertical">
      <ion-col>
        <app-email-sended-message
          *ngIf="isSended"
          header="EMAIL_MESSAGE_COMPONENT.TITLE"
          descriptionStart="EMAIL_MESSAGE_COMPONENT.DESCRIPTION_START"
          [userEmail]="form.value.email"
        ></app-email-sended-message>
        <ion-fab class="back" *ngIf="!isSended">
          <ion-fab-button href="/auth" size="small">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </ion-fab-button>
        </ion-fab>
        <form [formGroup]="form" *ngIf="!isSended">
          <ion-item class="header input" lines="none">
            <h3>{{ 'REGISTER.CREATE_ACCOUNT' | translate }}</h3>
          </ion-item>

          <app-input
            type="input"
            [form]="form"
            formControlName="appName"
            label="REGISTER.LOCATION"
            [submittedError]="validationError"
          ></app-input>

          <ion-label color="danger" *ngIf="appNameDoesntExist" class="font-size__16">
            {{ 'REGISTER.LOCATION_MISSING' | translate }}
          </ion-label> 

          <app-input
            type="input"
            [form]="form"
            formControlName="email"
            label="REGISTER.EMAIL"
            [submittedError]="validationError"
          ></app-input>

          <ion-label color="danger" *ngIf="accountExist" class="font-size__16">
            {{ 'REGISTER.ACCOUNT_EXIST' | translate }}
          </ion-label> 

          <app-input
            [type]="passwordEye ? 'text' : 'password'"
            [form]="form"
            formControlName="password"
            label="REGISTER.PASSWORD"
            [showPasswordEye]="true"
            [(passwordEye)]="passwordEye"
            [submittedError]="validationError"
          ></app-input>

          <app-input
            [type]="passwordEye ? 'text' : 'password'"
            [form]="form"
            formControlName="passwordConf"
            label="REGISTER.REPEAT_PASSWORD"
            [showPasswordEye]="true"
            [(passwordEye)]="passwordEye"
            [submittedError]="validationError"
          ></app-input>

          <ion-label
            *ngIf="!form.get('passwordConf').valid && (form.get('passwordConf').touched || validationError)"
            color="danger"
            class="font-size__16"
          >
            {{ 'REGISTER.PASSWORD_EQUALITY' | translate }}
          </ion-label> 

          <app-input
            type="input"
            [form]="form"
            formControlName="firstName"
            label="REGISTER.FIRST_NAME"
            [submittedError]="validationError"
          ></app-input>

          <app-input
            type="input"
            [form]="form"
            formControlName="lastName"
            label="REGISTER.LAST_NAME"
            [submittedError]="validationError"
          ></app-input>

          <app-checkbox
            [form]="form"
            [slot]="'start'"
            formControlName="rememberMe"
            label="AUTH.REMEMBER_ME"
          ></app-checkbox>

          <div class="regulations">
            <h1>{{ "REGISTER.CONDITIONS_HEADER" | translate }}</h1>
            <ion-item lines="none">
              <ion-checkbox
                (ionChange)="regulationsAccepted = !regulationsAccepted"
                [checked]="regulationsAccepted"
              ></ion-checkbox>
              <ion-label>
                <a routerLink="/legal/application-rules">
                  {{ "REGISTER.SERVICES_REGULATIONS" | translate }}*
                </a>
              </ion-label>
            </ion-item>
            <ion-item lines="none">
              <ion-checkbox
                (ionChange)="privacyPolicy = !privacyPolicy"
                [checked]="privacyPolicy"
              ></ion-checkbox>
              <ion-label>
                <a routerLink="/legal/privacy-policy">
                  {{ "REGISTER.PRIVACY_POLICY" | translate }}*
                </a>
              </ion-label>
            </ion-item>
          </div>

          <ion-button
            class="register-btn"
            (click)="Save()"
            size="large"
            [disabled]="!regulationsAccepted || !privacyPolicy"
            expand="block"
          >
            {{ 'REGISTER.BUTTON_CREATE_ACCOUNT' | translate }}</ion-button
          >
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
